module.exports = __webpack_public_path__ + "664f9b7091bd841bda5c0b010b8bf22c.png";